var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.555664,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#B378FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5557 26C20.4017 26 22.0987 25.365 23.4527 24.312L27.8487 28.708L29.2627 27.294L24.8667 22.898C25.9207 21.543 26.5557 19.846 26.5557 18C26.5557 13.589 22.9667 10 18.5557 10C14.1447 10 10.5557 13.589 10.5557 18C10.5557 22.411 14.1447 26 18.5557 26ZM18.5557 12C21.8647 12 24.5557 14.691 24.5557 18C24.5557 21.309 21.8647 24 18.5557 24C15.2467 24 12.5557 21.309 12.5557 18C12.5557 14.691 15.2467 12 18.5557 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9675 16.586C20.3465 16.966 20.5555 17.468 20.5555 18H22.5555C22.5555 16.935 22.1395 15.931 21.3815 15.172C19.8675 13.66 17.2425 13.66 15.7295 15.172L17.1415 16.588C17.9015 15.83 19.2115 15.832 19.9675 16.586Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon2);
export default __webpack_public_path__ + "static/media/searchIcon2.ca03da57621059d492a869fa5183aff6.svg";
export { ForwardRef as ReactComponent };